import React, { useCallback, useEffect, type ReactNode } from 'react';
import { SpotlightPulse } from '@atlaskit/onboarding';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import {
	LOZENGE_MESSAGE_ID,
	PULSE_MESSAGE_ID,
	useUserSpotlightProperty,
} from '../../../controllers/use-cross-join-eligibility-check/spotlight-check/index.tsx';

interface ParentComponentProps {
	children: ReactNode;
	showPulse: boolean;
}

export const ProjectPageMenuItemWithJoinTeamPulse = ({
	children,
	showPulse,
}: ParentComponentProps) => {
	const [markAsSpotlightPulseSeen] = useUserSpotlightProperty(PULSE_MESSAGE_ID);
	const [markAsJoinTeamLozengeSeen] = useUserSpotlightProperty(LOZENGE_MESSAGE_ID);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const stopPulsing = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'lozenge',
			}),
			'crossJoinTeamSidebar',
		);
		markAsJoinTeamLozengeSeen();
	}, [markAsJoinTeamLozengeSeen, createAnalyticsEvent]);

	useEffect(() => {
		markAsSpotlightPulseSeen(); // mark as seen after first view
	});

	return (
		<SpotlightPulse
			pulse={showPulse}
			radius={3}
			onClick={stopPulsing}
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure -- PLEASE FIX - ENABLING FLAT LINT CONFIG
			testId="navigation-apps-sidebar-common.ui.shortcuts.pages-menu-item.cross-join-team-nudge-provider.cross-join-nudge-pulse"
		>
			{children}
		</SpotlightPulse>
	);
};
